import React from 'react';
import { UserPlus, Trash2, FilterX, Upload, Building, X } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';
import { Progress } from '../ui/progress';

const EmployeesHeader = ({
  t,
  selectedDepartement,
  resetDepartementFilter,
  selectedEmployees,
  selectionProgress,
  setShowImportModal,
  setShowAddModal,
  showInactive,
  setShowInactive,
  showSuspended,
  setShowSuspended,
  showArchived,
  setShowArchived,
}) => (
  <div className="space-y-3">
    <div className="flex items-start justify-between gap-4 flex-wrap">
      <div className="flex-1 min-w-[300px]">
        <h1 className="text-3xl font-bold tracking-tight">{t('employees.title')}</h1>
        <div className="flex items-center space-x-2 mt-1 flex-wrap gap-2">
          <p className="text-muted-foreground">{t('employees.subtitle')}</p>
          {selectedDepartement && (
            <div className="flex items-center space-x-2">
              <Badge variant="outline" className="flex items-center space-x-1">
                <Building className="h-3 w-3" />
                <span>{selectedDepartement.name}</span>
              </Badge>
              <Button variant="ghost" size="sm" onClick={resetDepartementFilter} className="h-6 w-6 p-0">
                <X className="h-3 w-3" />
              </Button>
            </div>
          )}
        </div>
        {selectedEmployees.length > 0 && (
          <div className="mt-2 flex items-center space-x-2">
            <Badge variant="secondary">{selectedEmployees.length} {t('common.selected')}</Badge>
            <Progress value={selectionProgress} className="w-32 h-2" />
          </div>
        )}
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        {selectedDepartement && (
          <Button variant="outline" size="sm" onClick={resetDepartementFilter}>
            <FilterX className="mr-2 h-4 w-4" />
            {t('common.filter')}
          </Button>
        )}
        {selectedEmployees.length > 0 && (
          <Button variant="outline" size="sm">
            <Trash2 className="mr-2 h-4 w-4" />
            {t('common.delete')} ({selectedEmployees.length})
          </Button>
        )}
        <Button variant="outline" size="sm" onClick={() => setShowImportModal(true)}>
          <Upload className="mr-2 h-4 w-4" />
          {t('common.import')}
        </Button>
        <Button size="sm" onClick={() => setShowAddModal(true)}>
          <UserPlus className="mr-2 h-4 w-4" />
          {t('employees.addEmployee')}
        </Button>
      </div>
    </div>
    <div className="flex items-center gap-4 flex-wrap">
      <div className="flex items-center space-x-2">
        <Checkbox id="toggle-inactive" checked={showInactive} onCheckedChange={setShowInactive} />
        <Label htmlFor="toggle-inactive" className="text-sm cursor-pointer">{t('employeesPage.filters.showInactive')}</Label>
      </div>
      <div className="flex items-center space-x-2">
        <Checkbox id="toggle-suspended" checked={showSuspended} onCheckedChange={setShowSuspended} />
        <Label htmlFor="toggle-suspended" className="text-sm cursor-pointer">{t('employeesPage.filters.showSuspended')}</Label>
      </div>
      <div className="flex items-center space-x-2">
        <Checkbox id="toggle-archived" checked={showArchived} onCheckedChange={setShowArchived} />
        <Label htmlFor="toggle-archived" className="text-sm cursor-pointer">{t('employeesPage.filters.showArchived')}</Label>
      </div>
    </div>
  </div>
);

export default EmployeesHeader;
